var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphFunctionSocial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 13)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAB61",
    cx: 32,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5AA0FF",
    cx: 55,
    cy: 44,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD74B",
    cx: 9,
    cy: 44,
    r: 9
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#AAAAAC",
    transform: "rotate(33 20.543 27.248)",
    x: 18.043,
    y: 18.748,
    width: 5,
    height: 17,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#AAAAAC",
    transform: "rotate(90 31.5 44)",
    x: 29,
    y: 33,
    width: 5,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.333 19.847-.839.545a2 2 0 0 0-.588 2.767l7.08 10.902a2 2 0 0 0 2.767.588l.839-.544a2 2 0 0 0 .588-2.767L42.1 20.435a2 2 0 0 0-2.767-.588z",
    fill: "#AAAAAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphFunctionSocial);
export default __webpack_public_path__ + "static/media/icons_graph_function_social.094c544e2ef625c6eae65538a39c2b1e.svg";
export { ForwardRef as ReactComponent };